import fetch from "cross-fetch";
import _ from "lodash";
import log from "loglevel";
import queryString from "qs";
import cookie from "js-cookie";

const DOMAIN = process.env.VUE_APP_API_SHARE_DOMAIN || "/";

interface apiParams<T> {
  method: string;
  endpoint: string;
  directUrl?: string;
  id?: string;
  body?: any;
  queryParams?: T;
  locale?: string;
  isRequestFormData?: boolean;
}

export interface apiResponse {
  response: Response;
}

export default async <T_REQ, T_RES>(
  params: apiParams<T_REQ>
): Promise<T_RES & apiResponse> => {
  const headers: any = {
    "X-CSRF-Token": cookie.get("XSRF-TOKEN") || "",
  };

  if (!params.isRequestFormData) {
    headers["Content-Type"] = "application/json; charset=utf-8";
  }

  const match = window.location.pathname.split("/");
  const locale = params.locale ? params.locale : match[1] || "ja-jp";

  const credentials: any = {
    mode: "cors",
    credentials: undefined,
  };

  if (!params.directUrl) {
    credentials.credentials = "include";
  }

  const getRequest = (method: string) => {
    switch (method) {
      case "GET":
      case "DELETE":
        return { method, headers, ...credentials };
      case "POST":
      case "PATCH":
      case "PUT": {
        let requestBody = null;
        // 基本 POST、PUT は JSON 形式
        requestBody = JSON.stringify(params.body);

        // JSON 形式でパラメータを送れない場合は formData 形式にする
        if (params.isRequestFormData) {
          const form = new FormData();
          Object.keys(params.body).forEach((key: any) =>
            form.append(key, params.body[key])
          );
          requestBody = form;
        }
        return {
          method,
          body: requestBody,
          headers,
          ...credentials,
        };
      }
      default:
        log.error(`method no match error:${method}`);
        return {};
    }
  };
  log.debug("env:", process.env);
  let apiPath = `${DOMAIN}${locale}/${params.endpoint}`;

  if (params.directUrl) {
    apiPath = params.directUrl;
  } else {
    if (params.id) {
      apiPath += "/" + params.id;
    }

    if (_.size(params.queryParams as any)) {
      apiPath += `?${queryString.stringify(params.queryParams)}`;
    }
    log.debug("body:", params.body);
    log.debug("apiPath:", apiPath);
  }

  try {
    const response = await fetch(apiPath, getRequest(params.method));

    // 200じゃない場合はスロー
    if (!response.ok) {
      throw response;
    }

    const contentType = response.headers.get("content-type");
    if (contentType && contentType.includes("application/json")) {
      const json = (await response.json()) as T_RES & apiResponse;
      json.response = response;

      return json;
    } else {
      return { response: response } as T_RES & apiResponse;
    }
  } catch (ex) {
    log.error("error response:", ex);
    throw ex;
  }
};
